/**
 * Users domain — admin UI registration (Sub-project III).
 *
 * Injects the per-user action toolbar into the generic-framework
 * detail page via the `detailHeader` slot.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import UserAdminActions from './components/UserAdminActions.vue';

registerAdminUI('users.userprofile', {
    slots: {
        detailHeader: UserAdminActions,
    },
});
